export default "__VITE_ASSET__4XpWEuja__"